import { render } from "./patient-info.vue?vue&type=template&id=9c9868ca&scoped=true"
import script from "./patient-info.vue?vue&type=script&lang=js"
export * from "./patient-info.vue?vue&type=script&lang=js"

import "./patient-info.vue?vue&type=style&index=0&id=9c9868ca&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9868ca"]])

export default __exports__